import React from "react";
import { Icon } from "@iconify/react";
import { checkPermission } from "@comps/commonFunctions";
import "./layouts-styles.css";

/**
 * A page the signed-in user's role has to be granted before they see it.
 *
 * The sidebar has always been filtered by permission, but nothing stood
 * between a route and its component — so a role with a page withheld
 * could still reach it by typing the path, following an old link, or
 * pressing Back, and the list rendered in full. Hiding the menu item is
 * not access control.
 *
 * The server refuses those requests too (see the case list endpoint and
 * the `permission:` middleware on the rest). This is what the person
 * reads when they land somewhere they were not granted, instead of an
 * empty table over a failed request.
 *
 * `permission` may be a single key or several; holding any one of them
 * is enough, which mirrors CheckPermission on the API side.
 */
const BaseRequirePermission = ({ permission, children }) => {
  const keys = Array.isArray(permission) ? permission : [permission];
  const allowed = keys.some((key) => checkPermission(key));

  if (allowed) {
    return children;
  }

  return (
    <div className="state-block">
      <span className="state-mark">
        <Icon icon="tabler:lock" width={ 28 } />
      </span>
      <span className="state-title">You don't have access to this page</span>
      <p className="state-desc">
        Your role hasn't been given permission to view it. Ask an administrator
        if you think you should have it.
      </p>
    </div>
  );
};

export default BaseRequirePermission;
